<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" color="#fff" type="ball-clip-rotate-multiple">
	<p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
<router-outlet>
		<app-language-switcher></app-language-switcher>	
</router-outlet>